import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  root: {
    width: '100%',
    height: 150,
    paddingTop: 50,
    textAlign: 'center'
  },
})

export {
  useStyles
}
